import "./ChildOrdersStep.scss";
import {IComponentOptions} from "angular";
import {ChildOrdersService} from "../../../../../../orders/services/child-orders/ChildOrdersService";
import {EquityOrderWizardStore} from "../../../place-equity-order-wizard/store/EquityOrderWizardStore";
import {isNotNull} from "../../../../../../js/util/UtilFunctions";
import {Observable, ReplaySubject} from "rxjs";
import {ChildOrder} from "../../models/ChildOrder";
import {CurrentUserService} from "../../../../../../services/user/CurrentUserService";

export const ChildOrdersStep = "tfChildOrdersStep";

export function childOrdersStep(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/steps/child-orders/ChildOrdersStep.html`,
        bindings: {
            store: "<"
        },
        controllerAs: "ctrl",
        controller: ChildOrdersStepController
    };
}

export class ChildOrdersStepController {

    /** @input */
    public readonly store: EquityOrderWizardStore;
    public readonly childOrders$ = new ReplaySubject<Array<ChildOrder>>(1);
    public readonly remainingQuantity$ = new ReplaySubject<number>(1);
    private readonly destroyed$ = new ReplaySubject<boolean>(1);
    public isOma: boolean = false;
    /** @ngInject */
    public constructor(private readonly childOrdersService: ChildOrdersService,
                       private readonly currentUserService: CurrentUserService) {
    }
    public openAddChildOrderModal() {
        this.childOrdersService.open(this.store, null, null);
    }
    public openEditChildOrderModal(childOrder: ChildOrder, index: number | null) {
        this.childOrdersService.open(this.store, childOrder, index);
    }

    public $onInit(): void {
        this.currentUserService.current.subscribe(currentUser => this.isOma = currentUser.isOma());
        this.watchChildOrders();
        Observable.combineLatest(this.store.current, this.childOrders$)
                  .subscribe(([parentOrder, childOrders]) => {
                      if (childOrders) {
                          this.remainingQuantity$.next(
                              childOrders.reduce((qtyLeft, childOrder) => qtyLeft - (childOrder.quantity ?? 0),
                                                 parentOrder.quantity));
                      } else {
                          this.remainingQuantity$.next(parentOrder.quantity);
                      }
                  });
    }
    public removeOrder(index: number) {
        this.store.removeChildOrder(index);
    }

    private watchChildOrders() {
        this.store
            .current
            .takeUntil(this.destroyed$)
            .map((d) => d.childOrders)
            .filter(isNotNull)
            .distinctUntilChanged()
            .subscribe((childOrders) => this.childOrders$.next(childOrders));
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
